// Matches the row action buttons in the agent and knowledge tables
const actionIconButtonStyle = {
  minWidth: '44px',
  width: '44px',
  height: '44px',
  borderRadius: '10px',
  background: '#F1F5F9',
  borderColor: 'rgba(15, 23, 42, 0.06)',
  color: '#1841ff',
  padding: '0.5rem',
};

export default actionIconButtonStyle;
